"use strict";

import http from "@/http";

const getCompanies = async (excludeBuiltIn = false) => {
  let response;
  if (excludeBuiltIn) {
    response = await http.get("/companies/excludeBuiltIn");
  } else {
    response = await http.get("/companies");
  }
  return response.data;
};

const addCompany = async company => {
  const response = await http.post("/companies", { company: company });
  return response.data;
};

const updateCompany = async company => {
  const response = await http.put(`/companies/${company._id}`, {
    company: company
  });
  return response.data;
};

const deleteCompany = async id => {
  const response = await http.delete(`/companies/${id}`);
  return response.data;
};

const isValidIdentifier = async (id, number) => {
  const response = await http.get(
    `/companies/${id}/is-valid-identifier/${number}`
  );
  return response.data;
};

const isValidName = async (id, name) => {
  const response = await http.get(`/companies/${id}/is-valid-name/${name}`);
  return response.data;
};

const isValidEmail = async (id, email) => {
  const response = await http.get(`/companies/${id}/is-valid-email/${email}`);
  return response.data;
};

const getAllVisitsFromAllContractors = async (id, filter) => {
  const params = filter ? `?filter=${filter}` : '';
  const response = await http.get(`/companies/${id}/history${params}`);
  return response.data;
};

const editVisit = async (id, visit) => {
  const response = await http.post(
    `/companies/${id}/history/${visit.id}/${visit.dateOfVisit}`,
    { visit: visit }
  );
  return response.data;
};

const setEgress = async visit => {
  const response = await http.post(
    `/companies/egress/${visit.id}/${visit.endOfVisit}/${visit.hasRequestAccess}`
  );
  return response.data;
};

export default {
  getCompanies,
  addCompany,
  updateCompany,
  deleteCompany,
  isValidIdentifier,
  isValidName,
  isValidEmail,
  getAllVisitsFromAllContractors,
  editVisit,
  setEgress
};
